export type ResultError<ErrorE> = {
  success: false
  error: ErrorE
}

export type ResultOk<DataD = undefined> = {
  success: true
  data: DataD | undefined
}

export type Result<ErrorE, DataD = undefined> =
  | ResultError<ErrorE>
  | ResultOk<DataD>

export const createSuccessResult = <DataD>(data?: DataD): ResultOk<DataD> => ({
  success: true,
  data,
})

export const createErrorResult = <ErrorE>(
  error: ErrorE
): ResultError<ErrorE> => ({
  success: false,
  error,
})
